import Vue from 'vue'
import VueRouter from 'vue-router'
 
//2.调用vue.use() 函数，把 VueRouter 安装为 Vue 的插件
//vue.use()函数的作用，就是来安装插件的
Vue.use(VueRouter)

import Home from '../pane/Home.vue'
import Browse from '../pane/Browse.vue'
import Search from '../pane/Search.vue'
import Analysis from '../pane/Analysis.vue'
import Visualization from '../pane/Visualization.vue'
import Download from '../pane/Download.vue'
import Tutorial from '../pane/Tutorial.vue'
import About from '../pane/About.vue'
import SearchGene from '../pane/SearchPane/SearchGene.vue'
import SearchRNA from '../pane/SearchPane/SearchRNA.vue'
import SearchSNP from '../pane/SearchPane/SearchSNP.vue'
import SearchMethylation from '../pane/SearchPane/SearchMethylation.vue'
import SearchMetabolite from '../pane/SearchPane/SearchMetabolite.vue'
import SearchProtein from '../pane/SearchPane/SearchProtein.vue'

import Location from '../pane/VisualizationPane/Location.vue'
import PPI from '../pane/VisualizationPane/PPI.vue'
import Relation from '../pane/VisualizationPane/Relation.vue'
import Expression from '../pane/VisualizationPane/Expression.vue'
import Enrichment from '../pane/AnalysisPane/EnrichmentPane/Enrichment.vue'
import Conventional from '../pane/AnalysisPane/EnrichmentPane/Conventional.vue'
import GTXBlood from '../pane/AnalysisPane/EnrichmentPane/GTXBlood.vue'
import GTXBrain from '../pane/AnalysisPane/EnrichmentPane/GTXBrain.vue'
import DisGeNET from '../pane/AnalysisPane/EnrichmentPane/DisGeNET.vue'

import GeneExpression from '../pane/AnalysisPane/DifferentialPane/GeneExpression.vue'
import DNAMethylation from '../pane/AnalysisPane/DifferentialPane/DNAMethylation.vue'

import Prediction from '../pane/PredictionPane/Prediction.vue'
import PredictionSelect from '../pane/PredictionPane/PredictionSelect.vue'
// import PredictionResult from '../pane/PredictionPane/PredictionResult.vue'
// import PredictionTool from '../pane/PredictionPane/PredictionTool.vue'

const router = new VueRouter({
routes:[{
        path:'/',
        name:'Home',
        component:Home,
    },
    {
    path:'/browse',
    name:'browse',
    component:Browse,
    children:[{
            path:'MDD',
            name:'MDD',
            component:Browse
        },{
            path:'BD',
            name:'BD',
            component:Browse
        },{
            path:'SZ',
            name:'SZ',
            component:Browse
        },{
            path:'AX',
            name:'AX',
            component:Browse
        }]
    },
    {  
        path:'/search',
        component:Search,
        children:[{
            path:'gene',
            name:'gene',
            component:SearchGene,
        },{
            path:'snp',
            name:'snp',
            component:SearchSNP,
        },{
            path:'rna',
            name:'rna',
            component:SearchRNA,
        },{
            path:'methylation',
            name:'methylation',
            component:SearchMethylation,
        },{
            path:'metabolite',
            name:'metabolite',
            component:SearchMetabolite,
        },{
            path:'protein',
            name:'protein',
            component:SearchProtein,
        }]
    },
    // {
    //     path:'/prediction',
    //     component:Prediction,
    //     children:[
    //         {
    //           path:'results',
    //           //也不使用懒加载，先在文件头部提前引入
    //           component:PredictionResult,
    //         },
    //         {
    //             path:'tool',
    //             //也不使用懒加载，先在文件头部提前引入
    //             component:PredictionTool
    //         }
    //       ]
    // },
    {
        path:'/analysis',
        component:Analysis,
        children:[{
            path:'enrichment',
            component:Enrichment,
            children:[
                {
                    path:'conventional',
                    component:Conventional
                },{
                    path:'weat_gtxblood',
                    component:GTXBlood
                },{
                    path:'weat_gtxbrain',
                    component:GTXBrain
                },{
                    path:'weat_disgenet',
                    component:DisGeNET
                }
            ]
            },{
            path:'differential',
            component:Enrichment,
            children:[
                {
                    path:'methylation',
                    component:DNAMethylation
                },{
                    path:'expression',
                    component:GeneExpression
                }
                ]
            },
            //     {
            //   path:'go',
            //   component:GO
            // }
            // ,{
            //     path:'kegg',
            //     component:KEGG
            // },
            {
                path:'prediction',
                component:PredictionSelect
            },
          ]
    },{
        path:'/visualization',
        component:Visualization,
        children:[
            {
              path:'location',
              //也不使用懒加载，先在文件头部提前引入
              component:Location
            },
            {
                path:'ppi',
                //也不使用懒加载，先在文件头部提前引入
                component:PPI
            },
            {
                path:'relation',
                //也不使用懒加载，先在文件头部提前引入
                component:Relation
            },
            // {
            //     path:'expression',
            //     component:Expression
            // }
          ]
    },
    {
        path:'/download',
        component:Download
    },
    {
        path:'/tutorials',
        component:Tutorial
    },
    {
        path:'/about',
        component:About
    }
]})


export default router